import React from 'react';
import { Divider, Timeline, Typography } from 'antd';

// Historia del problema: cada detección es un punto de la línea de tiempo.
// Es lo que convierte "Requiere reparación. ×12" en algo legible.
// Extraído de HallazgoDetailDrawer como componente presentacional puro para
// poder testearlo sin montar el drawer completo (que requiere mockear
// providers, rutas y varias llamadas a API).
function HistoriaProblema({ detecciones }) {
  if (!detecciones || detecciones.length <= 1) return null;

  return (
    <>
      <Divider orientation="left">Historia del problema</Divider>
      <Timeline
        items={detecciones.map((d) => ({
          color: d.estado === 'ACTIVA' ? 'red' : 'gray',
          children: (
            <div>
              <Typography.Text strong className="text-sm">
                {new Date(d.createdAt).toLocaleDateString('es-CL')}
                {d.id_mantencion_origen ? ` · Mantención #${d.id_mantencion_origen}` : ''}
              </Typography.Text>
              <div className="text-sm text-slate-700">{d.descripcion}</div>
              {d.detectado_por ? (
                <Typography.Text type="secondary" className="text-xs">
                  Detectó: {d.detectado_por}
                </Typography.Text>
              ) : null}
              {d.razon_cierre ? (
                <div>
                  <Typography.Text type="secondary" className="text-xs">
                    Cierre: {d.razon_cierre}
                  </Typography.Text>
                </div>
              ) : null}
            </div>
          ),
        }))}
      />
    </>
  );
}

export default HistoriaProblema;
